<ng-otp-input [formCtrl]="otpFormControl"
  [config]="otpConfig"
></ng-otp-input>
